<template>
  <div class="home">
    <div class="flex-box-view user-recharge-page">
      <otherHeaderTop headerTitle="充值"></otherHeaderTop>
      <div class="recharge-content">
        <div class="new-s-custom-tabs-wrap recharge-tab">
          <!-- <div class="tab-bar-line"></div> -->
          <div class="s-custom-tab-bar">
            <div class="tab-inner">
              <div
                @click="changePayType('1')"
                :class="[pay_type == '1' ? 'custom-tab-item-active' : '']"
                class="custom-tab-item"
              >
                <img src="../../../assets/yun.png" alt="" class="tab-icon" />
                <span>云闪付</span>
              </div>
              <div
                @click="changePayType('2')"
                :class="[pay_type == '2' ? 'custom-tab-item-active' : '']"
                class="custom-tab-item tab-anim-left"
              >
                <img src="../../../assets/zhi.png" alt="" class="tab-icon" />
                <span>支付宝</span>
              </div>
              <!-- <div
                @click="changePayType('3')"
                :class="[pay_type == '3' ? 'custom-tab-item-active' : '']"
                class="custom-tab-item tab-anim-left"
              >
                <span>银联</span>
              </div> -->
            </div>
          </div>
          <div class="s-custom-tab-content-wrap">
            <div class="recharge-amount-wrap">
              <div class="recharge-amount-content-list">
                <div
                  @click="changeItem(item, index)"
                  :class="[index == itemIndex ? 'active' : '']"
                  v-for="(item, index) in list"
                  :key="index"
                  class="amount-item"
                >
                  <span class="amount-price">{{ item.price }}</span>
                  <!-- <div class="zengsong-tag-wrap">
                    <text v-if="item.send > 0">赠:{{ item.send }}</text>
                  </div> -->
                  <div class="size-mask"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-btn-wrap">
      <div class="left-total-amount">
        <div class="amount-label">
          支付金额：<span>{{ money }}元</span>
        </div>
        <!-- <div class="amount-font">
          <span>{{ money }}元</span>
        </div> -->
      </div>
      <div class="recharge-btn" @click="charge">
        <span> 确认充值 </span>
      </div>
    </div>
    <!-- 生成二维码弹窗 -->
    <shareQrcode
      title="扫码充值"
      :showModal="showShareQrcode"
      :url="rechargeUrl"
      @close="closeShareQrcode"
    ></shareQrcode>
  </div>
</template>

<script>
import QRCode from "qrcode";
import shareQrcode from "@/components/common/modalShareQrcode.vue";
import {
  jiuJiaPay,
  getRechargelist,
  realNameAuthentication,
  kamiPay,
  getUserInfo,
  Recgargewx,
  ApiAddTrans,
  ApiAdddgfht,
} from "@/api/index";
import customer from "../../../../public/config.json";

import otherHeaderTop from "@/components/otherHeaderTop.vue";
export default {
  components: { otherHeaderTop, shareQrcode },
  data() {
    return {
      Exampleobj: {
        idNum: "",
        realName: "",
        password: "",
        password1: "",
      },
      loading: false,
      wxorder: false,
      Realnameauthentication: false,
      onsubmit: true,
      isRealCheck: false,
      money: 0,
      select: false,
      left: 1,
      ready: false,
      index: 1,
      list: [],
      kami: "",
      obj: {
        goodsPrice: null,
        goodsId: null,
        goodsNum: 1,
      },
      // 新的
      safe_top: 0,
      user: {},
      pay_type: "1",
      items: [
        {
          g_coin: 10,
          money: 10,
        },
        {
          g_coin: 20,
          money: 20,
        },
        {
          g_coin: 30,
          money: 30,
        },
        {
          g_coin: 40,
          money: 40,
        },
        {
          g_coin: 50,
          money: 50,
        },
        {
          g_coin: 60,
          money: 60,
        },
        {
          g_coin: 70,
          money: 70,
        },
        {
          g_coin: 80,
          money: 80,
        },
        {
          g_coin: 90,
          money: 90,
        },
        {
          g_coin: 90,
          money: 90,
        },
        {
          g_coin: 90,
          money: 90,
        },
        {
          g_coin: 90,
          money: 90,
        },
        {
          g_coin: 90,
          money: 90,
        },
        {
          g_coin: 90,
          money: 90,
        },
        {
          g_coin: 90,
          money: 90,
        },
        {
          g_coin: 90,
          money: 90,
        },
        {
          g_coin: 90,
          money: 90,
        },
        {
          g_coin: 90,
          money: 90,
        },
        {
          g_coin: 90,
          money: 90,
        },
      ],
      itemIndex: 0,
      rechargeUrl: "",
      showShareQrcode: false,
    };
  },

  mounted() {
    this.getrechangeList();
    getUserInfo().then((res) => {
      if (res.data.code == 200) {
        this.$store.commit("USER_INFO", res.data.data);
      }
    });
  },
  methods: {
    playAudio() {
      this.$store.commit("playAudio");
    },
    goPlay() {
      if (this.index == 1) {
        const userInfo = JSON.parse(localStorage.getItem("userInfo"));
        const customerServiceAddress = customer.customerServiceAddress;
        const url = customerServiceAddress.url;
        const noCanClose = customerServiceAddress.noCanClose;
        const kefu_id = customerServiceAddress.kefu_id;
        const token = customerServiceAddress.token;
        if (userInfo) {
          window.location.href = `${url}?noCanClose=${noCanClose}&token=${token}&kefu_id=${kefu_id}&phone=${userInfo.mobile}&nickName=${userInfo.name}`;
        } else {
          window.location.href = `${url}?noCanClose=${noCanClose}&token=${token}&kefu_id=${kefu_id}`;
        }
      } else {
        this.handlePay();
      }
    },
    handlePay() {
      if (!this.kami && !this.ready) {
        return false;
      }
      this.loading = true;

      if (this.select) {
        if (this.index == 0) {
          const obj = {
            coinItemId: this.obj.goodsId,
            coinItemNum: this.obj.goodsNum,
            coinItemAmount: this.obj.goodsPrice.toFixed(2),
          };
          this.wxorder = true;
          Recgargewx(obj).then((res) => {
            // window.open(res.data.data.url);
            // window.location.href = `weixin://${res.data.data.url}`;
            if (res.data.code == 200) {
              this.loading = false;
              const url = res.data.data.url;
              QRCode.toDataURL(url, { type: "image/png" }, (err, url) => {
                console.log(err, url, "转换结果");
                if (err) throw err;
                this.$refs.qrCode.innerHTML = `<img src="${url}"  alt="QR Code" width='100%'>`;
              });
            } else {
              this.wxorder = false;
            }
          });
        } else if (this.index == 4) {
          // console.log(123);
          if (this.obj.goodsId == null) {
            this.$message({
              duration: 1000,
              message: "请选择金额，再进行支付",
              type: "warning",
              customClass: "log_warning",
            });
          } else {
            jiuJiaPay(this.obj).then((res) => {
              console.log("九价", res);
              window.open(res.data.data);
            });
          }
        } else if (this.index == 3) {
          kamiPay({ password: this.kami }).then((res) => {
            if (res.data.code == 200) {
              this.kami = "";
              getUserInfo().then((res) => {
                if (res.data.code == 200) {
                  this.$store.commit("USER_INFO", res.data.data);
                }
              });
              this.$message({
                duration: 1000,
                type: "success",
                message: res.data.msg,
                customClass: "log_success",
              });
            } else {
              console.log(res);
              this.$message({
                duration: 1000,
                type: "error",
                message: res.data.msg,
                customClass: "log_success",
              });
            }
          });
        } else if (this.index == 2) {
          ApiAddTrans(this.obj).then((res) => {
            console.log("ApiAddTrans", res);
            console.log("res.data.data.payUrl;", res.data.data.payUrl);

            // window.location.href = res.data.data.payUrl;
          }); // this.$message({ duration: 1000,
          //   type: "success",
          //   message: "敬请期待",
          //   customClass: "log_success"
          // });
        } else if (this.index == 1) {
          // window.location.href =`weixin:// `
          console.log(1, this.obj);
          // mayi(this.obj).then((res) => {
          const data = { ...this.obj };
          console.log("国富汇通支付宝", data);
          ApiAdddgfht(data).then((res) => {
            if (res.data.code === 500) {
              this.$message({
                duration: 1000,
                message: res.data.msg,
                type: "warning",
                customClass: "log_warning",
              });
              return;
            }
            console.log("国富汇通支付宝", res, res.data.data.payurl);
            const url = res.data.data.payurl
              ? res.data.data.payurl
              : res.data.data.qrcode;
            // console.log(url,"lianjie")
            // window.location.href = res.data.data.payUrl
            this.wxorder = true;
            setTimeout(() => {
              console.log(1111);

              var canvas = document.getElementById("canvas"); //获取到canvas

              var code = document.getElementById("code"); //获取到code容器
              console.log(canvas, code, "测试222", url);
              QRCode.toCanvas(canvas, url, (error) => {
                if (error) console.error(error);

                console.log("success!");
              });

              var image = new Image(); //实例一个img

              image.src = canvas.toDataURL("image/png"); //转换成base64格式路径的png图片

              image.style.width = "100%"; //设置样式

              code.appendChild(image); //添加到code 容器中

              canvas.style.display = "none"; //隐藏掉canvas
            }, 200);
          });
        }
      } else {
        this.$message({
          duration: 1000,
          message: "请先同意《用户协议》，《隐私政策》等内容",
          type: "warning",
          customClass: "log_warning",
        });
      }
    },
    getrechangeList() {
      getUserInfo().then((res) => {
        this.isRealCheck = res.data.data.isRealCheck;
      });
      getRechargelist().then((res) => {
        this.list = res.data.data;
        this.money = res.data.data[0].price;
        this.obj.goodsId = res.data.data[0].id;
        this.obj.goodsPrice = res.data.data[0].price.toFixed(2);
      });
    },
    handleconfirmname() {
      this.onsubmit = false;
      realNameAuthentication(this.Exampleobj).then((res) => {
        if (res.data.code === 200) {
          const element = this.$refs.nameel;
          element.className += " animate__slideOutUp";
          this.transactionLink = "";
          setTimeout(() => {
            this.onsubmit = true;
            this.$message({
              duration: 1000,
              message: "实名认证成功",
              type: "success",
              customClass: "log_success",
            });
          }, 500);
        } else {
          this.onsubmit = true;
        }
      });
    },
    handleconfirmnamequxiao() {
      const element = this.$refs.nameel;
      element.className += " animate__slideOutDown";
      this.Exampleobj = {
        idNum: "",
        realName: "",
        password: "",
        password1: "",
      };
      setTimeout(() => {
        this.Realnameauthentication = false;
        this.changepassword = false;
        this.issign = false;
        this.wxorder = false;
        this.getUserInfo().then((res) => {
          if (res.data.code == 200) {
            this.$store.commit("USER_INFO", res.data.data);
          }
        });
      }, 400);
    },
    handlec(res) {
      this.obj.goodsId = res.id;
      this.obj.goodsPrice = res.price;
      this.money = res.price;
      this.list.forEach((e) => {
        e.isselect = false;
      });
      res.isselect = true;
      this.ready = true;
    },
    handleAgree() {
      this.select = !this.select;
    },
    handleindex(res) {
      this.index = res;
      const element = this.$refs.slider;
      if (res == 3) {
        this.left = 1 * element.offsetWidth + 3;
      } else {
        this.left = (res - 1) * element.offsetWidth + 3;
      }
    },
    // 新的
    changePayType(type) {
      this.$soundPlay("pkTab");
      this.pay_type = type;
    },
    getCharteItems() {},
    changeItem(item, index) {
      this.$soundPlay("boxSelect");
      this.itemIndex = index;
      this.obj.goodsId = item.id;
      this.obj.goodsPrice = item.price.toFixed(2);
      this.money = item.price;
    },
    charge() {
      this.obj.payType = this.pay_type;
      ApiAdddgfht(this.obj).then((res) => {
        if (res.data.code === 200) {
          // console.log("国富汇通支付宝", res, res.data.data.payurl);
          const url = res.data.data.payurl
            ? res.data.data.payurl
            : res.data.data.qrcode;
          // 处理成图片
          QRCode.toDataURL(url, { type: "image/png" }, (err, url) => {
            this.rechargeUrl = url;
            if (err) throw err;
          });
          this.showShareQrcode = true;
        }
        // setTimeout(() => {
        //   window.location.href = url
        // },200);
      });
    },
    closeShareQrcode() {
      this.showShareQrcode = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.charge {
  --head-height: 14 * 4.2px;
}

.zz-page {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  color: white;
  background-image: url("../../../assets/images/page_bkg.png");
  overflow-y: scroll;
  /* overflow-scrolling: touch;
	  -webkit-overflow-scrolling: touch; */
}

.user-recharge-page {
  position: relative;
  padding-bottom: 23.73 * 4.2px;
}

.flex-box-div {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 100%;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-top: -webkit-calc(var(--head-height));
  padding-top: calc(var(--head-height));
}

.user-recharge-page .recharge-content {
  position: relative;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  // overflow-y: scroll;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.user-recharge-page .recharge-content .ch-tab-box {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  height: 9.33 * 4.2px;
  margin: 3.2 * 4.2px 0 0 2 * 4.2px;
}

.user-recharge-page .recharge-content .ch-tab-box .ch-tab {
  position: relative;
  width: 30.13 * 4.2px;
  height: 8.4 * 4.2px;
  line-height: 8.4 * 4.2px;
  font-size: 3.87 * 4.2px;
  text-align: center;
  color: #7a7a7a;
  margin-right: 1.33 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../../assets/images/new_ch_tab_bg1.png");
}

.user-recharge-page .recharge-content .ch-tab-box .ch-tab.active {
  color: #fff;
  background-image: url("../../../assets/images/new_ch_tab_bg2.png");
}

.user-recharge-page .recharge-content .ch-tab-box .ch-tab .profit-tag {
  position: absolute;
  top: -2.67 * 4.2px;
  right: -2.67 * 4.2px;
  width: 8.93 * 4.2px;
  height: 5.2 * 4.2px;
  line-height: 5.2 * 4.2px;
  text-align: center;
  font-size: 3.33 * 4.2px;
  color: #ffde28;
  background-size: 100% 100%;
  background-image: url("../../../assets/images/k10.png");
}

.user-recharge-page .recharge-content .new-s-custom-tabs-wrap {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  // overflow: hidden;
  // overflow-y: scroll;
}

.user-recharge-page
  .recharge-content
  .new-s-custom-tabs-wrap
  .s-custom-tab-bar {
  width: 386.4px;
  margin: 0 4 * 4.2px;
}

.user-recharge-page
  .recharge-content
  .new-s-custom-tabs-wrap
  .s-custom-tab-content-wrap {
  // -webkit-box-flex: 1;
  // -webkit-flex: 1;
  // -ms-flex: 1;
  // flex: 1;
  height: calc(100vh - 320px);
  // overflow-y: scroll;
}

.bottom-btn-wrap {
  width: 100%;
  height: 20.48 * 4.2px;
  overflow: hidden;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 4 * 4.2px;
  padding: 0 4 * 4.2px 2.67 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(10, 0, 76, 0.452);
  border-radius: 1.9 * 4.2px;
  position: absolute;
  bottom: 16.67 * 4.2px;
  left: 0;

  @media only screen and (max-width: 430px) {
    height: 20.48vw;
    margin-top: 4vw;
    padding: 0 4vw 2.67vw;
    bottom: 16.67vw;
    border-radius: 1.9vw;
  }
}

.bottom-btn-wrap .left-total-amount {
  width: 43.47 * 4.2px;
  height: 10.8 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;

  @media only screen and (max-width: 430px) {
    width: 43.47vw;
    height: 10.8vw;
  }
}

.bottom-btn-wrap .left-total-amount .amount-label {
  height: 6.67 * 4.2px;
  line-height: 3.81 * 4.2px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 400;
  color: #ffffff;
  font-style: normal;
  text-transform: none;
  font-size: 3.81 * 4.2px;
  margin: 2 * 4.2px 2.4 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 6.67vw;
    line-height: 3.81vw;
    font-size: 3.81vw;
    margin: 2vw 2.4vw;
  }
}

.bottom-btn-wrap .left-total-amount .amount-label span {
  color: #fffd97;
  letter-spacing: 0.24 * 4.2px;

  @media only screen and (max-width: 430px) {
    letter-spacing: 0.24vw;
  }
}

.bottom-btn-wrap .recharge-btn {
  width: 35 * 4.2px;
  height: 10 * 4.2px;
  line-height: 10 * 4.2px;
  color: #fff;
  font-size: 3.81 * 4.2px;
  text-align: center;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 500;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-size: 100% 100%;
  background-image: url("../../../assets/image3/home/exitButton.png");

  @media only screen and (max-width: 430px) {
    width: 35vw;
    height: 10vw;
    line-height: 10vw;
    font-size: 3.81vw;
  }
}

// .user-recharge-page .recharge-content .bottom-btn-wrap::after {
//   content: "";
//   width: 100%;
//   height: 22.974px;
//   position: absolute;
//   bottom: 19.6 * 4.2px;
//   left: 0;
//   background: url("../../../assets/images/bottom_line.png") no-repeat top right 10.08px;
//   background-size: 100% 23px;
// }

// .user-recharge-page .recharge-content .goods-recharge .tab-bar-line {
//   width: 397.614px;
//   height: 8.946px;
//   margin-left: 2.67 * 4.2px;
//   background: url("../../../assets/images/line3.png") no-repeat;
//   background-size: 397.614px 8.946px;
// }

.user-recharge-page .recharge-content .goods-recharge .recharge-btn {
  width: 68.8 * 4.2px;
  height: 20.27 * 4.2px;
  margin: 14.53 * 4.2px 0 0 122.974px;
  background: url("../../../assets/images/btn_bg2.png") center center / 100%
      100%,
    url("../../../assets/images/btn_bg1.png") center center / 100% 100%;
}

.user-recharge-page .recharge-content .goods-recharge .goods-tip {
  height: 8 * 4.2px;
  margin-top: 6.13 * 4.2px;
}

.user-recharge-page .recharge-content .goods-recharge .goods-tip .tag-ic {
  display: inline-block;
  width: 3.73 * 4.2px;
  height: 3.33 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../../assets/images/warning.png");
}

.user-recharge-page .recharge-content .goods-recharge .goods-tip .text {
  display: inline-block;
  font-size: 3.33 * 4.2px;
  color: #fff;
  margin-left: 1.2 * 4.2px;
}

.user-recharge-page .recharge-content .goods-recharge .goods-tip .bind-btn {
  display: inline-block;
  width: 21.6 * 4.2px;
  height: 6.67 * 4.2px;
  line-height: 6.67 * 4.2px;
  font-size: 2.67 * 4.2px;
  text-align: center;
  margin-left: 5.73 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../../assets/images/k11.png");
}

.user-recharge-page .recharge-content .goods-recharge .goods-tip1 {
  color: #fff;
  font-size: 4 * 4.2px;
  margin-top: 4 * 4.2px;
}

.user-recharge-page .recharge-content .goods-recharge .to-transfer {
  position: fixed;
  left: 0;
  bottom: 23.73 * 4.2px;
  width: 100%;
}

.user-recharge-page .recharge-content .goods-recharge .to-transfer .viewider {
  width: 99.07 * 4.2px;
  height: 22.974px;
  background: url("../../../assets/images/bottom_line.png") no-repeat top right
    2.4 * 4.2px;
  background-size: 100% 22.974px;
}

.user-recharge-page .recharge-content .goods-recharge .to-transfer .go-btn {
  float: right;
  width: 42.8 * 4.2px;
  height: 12.93 * 4.2px;
  line-height: 12.93 * 4.2px;
  font-size: 5.07 * 4.2px;
  text-align: center;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold, serif;
  font-weight: 700;
  margin: 4 * 4.2px 28.67 * 4.2px 2.53 * 4.2px 0;
  background-size: 100% 100%;
  background-image: url("../../../assets/images/recharge_btn.png");
}

.user-recharge-page .error-empty-text {
  color: #5d658f;
  text-align: center;
  font-size: 4.8 * 4.2px;
  margin-top: 40 * 4.2px;
}

.user-recharge-page .user-recharge-title-img {
  width: 12.4 * 4.2px;
  height: 5.07 * 4.2px;
}

.user-recharge-page .recharge-tips {
  padding: 0 5.33 * 4.2px 2.67 * 4.2px;
  font-size: 3.33 * 4.2px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  color: #ffffff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.user-recharge-page .recharge-tips image {
  margin-right: 1.33 * 4.2px;
  width: 3.73 * 4.2px;
  height: 3.33 * 4.2px;
}

.user-recharge-page .recharge-amount-wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 4 * 4.2px 0 4 * 4.2px;
  box-sizing: border-box;
  overflow-y: auto;
}

.user-recharge-page .recharge-amount-wrap .recharge-amount-content-list {
  width: 104%;
  overflow: hidden;
  padding-bottom: 10.67 * 4.2px;
}

.user-recharge-page .recharge-amount-wrap .amount-item {
  position: relative;
  width: 28.13 * 4.2px;
  height: 20.4 * 4.2px;
  background-image: url("../../../assets/image3/recharge/rechargeNotSelect.png");
  background-size: 100% 100%;
  margin-right: 3.2 * 4.2px;
  margin-bottom: 1.87 * 4.2px;
  float: left;
  overflow: hidden;
  color: #c9d5e5;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.user-recharge-page .recharge-amount-wrap .amount-item > text {
  font-size: 6.4 * 4.2px;
  display: block;
  margin-top: -5.33 * 4.2px;
}

.user-recharge-page .recharge-amount-wrap .amount-item .amount-price {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 6.67 * 4.2px;
  line-height: 6.67 * 4.2px;
  font-size: 3.33 * 4.2px;
  text-align: center;
  font-weight: bold;
  color: #fbddad;
}

.user-recharge-page .recharge-amount-wrap .amount-item .zengsong-tag-wrap {
  z-index: 10;
  width: 22.67 * 4.2px;
  height: 4.53 * 4.2px;
  position: absolute;
  top: 0.53 * 4.2px;
  left: 0.93 * 4.2px;
}

.user-recharge-page .recharge-amount-wrap .amount-item .zengsong-tag-wrap text {
  display: inline-block;
  width: 22.67 * 4.2px;
  height: 4.53 * 4.2px;
  line-height: 4.53 * 4.2px;
  font-size: 3.33 * 4.2px;
  padding: 0 0 0 1.07 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../../assets/images/k12.png");
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-bottom: 4 * 4.2px;
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask {
  width: 5.24 * 4.2px;
  height: 5.24 * 4.2px;
  background-image: url("../../../assets/home/jinbi.png");
  margin-top: 5 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 5.24vw;
    height: 5.24vw;
    margin-top: 5vw;
  }
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-2 {
  background-image: url("../../../assets/home/jinbi.png");
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-3 {
  background-image: url("../../../assets/home/jinbi.png");
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-4 {
  background-image: url("../../../assets/home/jinbi.png");
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-5 {
  background-image: url("../../../assets/home/jinbi.png");
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-6 {
  background-image: url("../../../assets/home/jinbi.png");
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-7 {
  background-image: url("../../../assets/home/jinbi.png");
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-8 {
  background-image: url("../../../assets/images/pay_size8.png");
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-9 {
  background-image: url("../../../assets/images/pay_size9.png");
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-10 {
  background-image: url("../../../assets/images/pay_size10.png");
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-11 {
  background-image: url("../../../assets/images/pay_size11.png");
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-12 {
  background-image: url("../../../assets/images/pay_size12.png");
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size {
  width: 9.73 * 4.2px;
  height: 9.87 * 4.2px;
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-2 {
  width: 11.6 * 4.2px;
  height: 9.6 * 4.2px;
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-3 {
  width: 12.67 * 4.2px;
  height: 9.47 * 4.2px;
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-4 {
  width: 11.47 * 4.2px;
  height: 9.47 * 4.2px;
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-5 {
  width: 14 * 4.2px;
  height: 9.73 * 4.2px;
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-6 {
  width: 14 * 4.2px;
  height: 9.73 * 4.2px;
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-7 {
  width: 14 * 4.2px;
  height: 9.73 * 4.2px;
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-8 {
  width: 17.47 * 4.2px;
  height: 10.4 * 4.2px;
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-9 {
  width: 18 * 4.2px;
  height: 15.2 * 4.2px;
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-10 {
  width: 12.8 * 4.2px;
  height: 9.6 * 4.2px;
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-11 {
  width: 12.53 * 4.2px;
  height: 12.27 * 4.2px;
}

.user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-12 {
  width: 23.2 * 4.2px;
  height: 14.4 * 4.2px;
}

.user-recharge-page .recharge-amount-wrap .amount-item.active {
  background-image: url("../../../assets/image3/recharge/rechargeSelect.png");
}

.user-recharge-page .recharge-amount-wrap .amount-item.active .size-mask.size {
  background-image: url("../../../assets/home/jinbi.png");
}

.user-recharge-page
  .recharge-amount-wrap
  .amount-item.active
  .size-mask.size-2 {
  background-image: url("../../../assets/images/pay_size_sel2.png");
}

.user-recharge-page
  .recharge-amount-wrap
  .amount-item.active
  .size-mask.size-3 {
  background-image: url("../../../assets/images/pay_size_sel3.png");
}

.user-recharge-page
  .recharge-amount-wrap
  .amount-item.active
  .size-mask.size-4 {
  background-image: url("../../../assets/images/pay_size_sel4.png");
}

.user-recharge-page
  .recharge-amount-wrap
  .amount-item.active
  .size-mask.size-5 {
  background-image: url("../../../assets/images/pay_size_sel5.png");
}

.user-recharge-page
  .recharge-amount-wrap
  .amount-item.active
  .size-mask.size-6 {
  background-image: url("../../../assets/images/pay_size_sel6.png");
}

.user-recharge-page
  .recharge-amount-wrap
  .amount-item.active
  .size-mask.size-7 {
  background-image: url("../../../assets/images/pay_size_sel7.png");
}

.user-recharge-page
  .recharge-amount-wrap
  .amount-item.active
  .size-mask.size-8 {
  background-image: url("../../../assets/images/pay_size_sel8.png");
}

.user-recharge-page
  .recharge-amount-wrap
  .amount-item.active
  .size-mask.size-9 {
  background-image: url("../../../assets/images/pay_size_sel9.png");
}

.user-recharge-page
  .recharge-amount-wrap
  .amount-item.active
  .size-mask.size-10 {
  background-image: url("../../../assets/images/pay_size_sel10.png");
}

.user-recharge-page
  .recharge-amount-wrap
  .amount-item.active
  .size-mask.size-11 {
  background-image: url("../../../assets/images/pay_size_sel11.png");
}

.user-recharge-page
  .recharge-amount-wrap
  .amount-item.active
  .size-mask.size-12 {
  background-image: url("../../../assets/images/pay_size_sel12.png");
}

.user-recharge-page .recharge-amount-total {
  width: 397.614px;
  overflow: hidden;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 5.73 * 4.2px 2.67 * 4.2px 0 2.67 * 4.2px;
}

.user-recharge-page .recharge-amount-total .btn-center {
  width: 41.07 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.user-recharge-page .recharge-amount-total .conversion-of-rmb-wrap {
  width: 53.6 * 4.2px;
}

.user-recharge-page
  .recharge-amount-total
  .conversion-of-rmb-wrap
  .selected-recharge-text {
  font-size: 2.93 * 4.2px;
  color: #92a1be;
}

.user-recharge-page
  .recharge-amount-total
  .conversion-of-rmb-wrap
  .selected-recharge {
  font-size: 6 * 4.2px;
  color: #ff532b;
  font-weight: 600;
}

.user-recharge-page
  .recharge-amount-total
  .conversion-of-rmb-wrap
  .selected-recharge
  text {
  font-size: 2.67 * 4.2px;
}

.user-recharge-page
  .recharge-amount-total
  .conversion-of-rmb-wrap
  .cdkey-input-box {
  width: 55.2 * 4.2px;
  height: 9.33 * 4.2px;
}

.user-recharge-page
  .recharge-amount-total
  .conversion-of-rmb-wrap
  .cdkey-input-box
  input {
  background: none;
  width: 53.33 * 4.2px;
  height: 100%;
  text-indent: 1.6 * 4.2px;
  color: #5eb8e8;
  font-size: 3.73 * 4.2px;
}

.user-recharge-page .recharge-amount-total .recharge-btn {
  font-size: 3.47 * 4.2px;
  color: #fff;
  display: inline-block;
  width: 41.07 * 4.2px;
  height: 9.33 * 4.2px;
  line-height: 9.33 * 4.2px;
  text-align: center;
  background-size: cover;
  border: 0 none;
  position: relative;
}

.user-recharge-page .recharge-amount-total .recharge-btn.cdkey-btn {
  margin-left: -8.946px;
}

.user-recharge-page .recharge-amount-total .recharge-btn.disable {
  background-size: cover;
}

.user-recharge-page .recharge-amount-total .hitCol {
  clear: both;
  text-align: left;
  color: rgba(255, 0, 0, 0.5);
  padding-top: 1.07 * 4.2px;
  font-size: 1.6 * 4.2px;
}

.user-recharge-page .recharge-total-box {
  width: 100%;
  overflow: hidden;
  padding: 5.33 * 4.2px 4 * 4.2px 0 4 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.user-recharge-page .recharge-total-box .prod-info {
  width: 386.4px;
  height: 104.16px;
  background-size: 386.4px 104.16px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #c9d5e5;
}

.user-recharge-page .recharge-total-box .prod-info .left-img {
  width: 30.4 * 4.2px;
  height: 22.67 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.user-recharge-page .recharge-total-box .prod-info .left-img image {
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 100%;
}

.user-recharge-page .recharge-total-box .prod-info .prod-name {
  width: 57.33 * 4.2px;
  height: 5.33 * 4.2px;
  margin-top: 1.33 * 4.2px;
}

.user-recharge-page .agCol {
  width: 100%;
  overflow: hidden;
  padding: 6.67 * 4.2px 2.67 * 4.2px 0 2.67 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.user-recharge-page .agree-error-text {
  color: #fd3477;
  font-size: 3.2 * 4.2px;
  padding: 0 3.2 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 3.47 * 4.2px;
  line-height: 3.47 * 4.2px;
  margin-top: 3.2 * 4.2px;
  text-align: center;
}

.dialog-box {
  background: none !important;
}

.dialog-box .user-recharge-page {
  padding: 0 !important;
}

.dialog-box .user-recharge-page .bottom-btn-wrap {
  margin-bottom: 4 * 4.2px;
}

.new-s-custom-tabs-wrap {
  width: 100%;
  height: auto;
  padding-top: 5.33 * 4.2px;
}

.new-s-custom-tabs-wrap .s-custom-tab-bar::-webkit-scrollbar {
  display: none;
}

.new-s-custom-tabs-wrap .s-custom-tab-bar {
  width: 100%;
  height: 8 * 4.2px;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-bottom: 1px solid #4f5e78;
}

.new-s-custom-tabs-wrap .s-custom-tab-bar .tab-inner {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%;
}

.new-s-custom-tabs-wrap .s-custom-tab-bar .custom-tab-item {
  float: left;
  -webkit-box-flex: 0;
  -webkit-flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: 26.67 * 4.2px;
  height: 7.73 * 4.2px;
  line-height: 7.73 * 4.2px;
  font-size: 3.33 * 4.2px;
  color: #fff;
  z-index: 11;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-size: 100% 100%;
  background-image: url("../../../assets/image3/share/notSelectedBack.png");
}

.new-s-custom-tabs-wrap
  .s-custom-tab-bar
  .custom-tab-item.custom-tab-item-active {
  color: #fff;
  background-image: url("../../../assets/image3/share/selectBack.png");
}

.new-s-custom-tabs-wrap .s-custom-tab-bar .custom-tab-item .icon {
  width: 4.13 * 4.2px;
  height: 3.2 * 4.2px;
  display: inline-block;
  background-size: cover;
  background-repeat: no-repeat;
  margin-right: 1.33 * 4.2px;
}

.new-s-custom-tabs-wrap .s-custom-tab-content-wrap {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
}

.recharge-tab {
  padding-top: 0;
}

.recharge-tab .s-custom-tab-bar {
  border-bottom: none;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
}

.recharge-tab .s-custom-tab-bar .tab-inner {
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.recharge-tab .s-custom-tab-bar .tab-inner .custom-tab-item {
  width: 21.6 * 4.2px;
  margin-right: 1.73 * 4.2px;
  margin-bottom: 2.8 * 4.2px;
  // background-image: url("../../../assets/images/k14.png") !important;
}

.recharge-tab .s-custom-tab-bar .tab-inner .custom-tab-item.no-margin-right {
  margin-right: 0;
}

.recharge-tab
  .s-custom-tab-bar
  .tab-inner
  .custom-tab-item.custom-tab-item-active {
  // background-image: url("../../../assets/images/k15.png") !important;
}

.recharge-tab
  .s-custom-tab-bar
  .tab-inner
  .custom-tab-item.custom-tab-item-active
  text {
  color: #18c5d5;
}

.recharge-tab .s-custom-tab-bar .tab-inner .custom-tab-item .tab-icon {
  width: 4 * 4.2px;
  height: 4 * 4.2px;
  margin-right: 1.07 * 4.2px;
  -webkit-border-radius: 0.67 * 4.2px;
  border-radius: 0.67 * 4.2px;
}

.recharge-tab .s-custom-tab-bar .tab-inner .custom-tab-item text {
  font-size: 3.33 * 4.2px;
  font-weight: 700;
  color: #7a7a7a;
}

.recharge-tab .tab-bar-line {
  width: 397.614px;
  height: 8.946px;
  margin-left: 2.67 * 4.2px;
  background: url("../../../assets/images/line4.png") no-repeat;
  background-size: 397.614px 8.946px;
}

@media only screen and (max-width: 430px) {
  .charge {
    --head-height: 14vw;
  }

  .user-recharge-page {
    padding-bottom: 23.73vw;
  }

  .user-recharge-page .recharge-content .ch-tab-box {
    height: 9.33vw;
    margin: 3.2vw 0 0 2vw;
  }

  .user-recharge-page .recharge-content .ch-tab-box .ch-tab {
    position: relative;
    width: 30.13vw;
    height: 8.4vw;
    line-height: 8.4vw;
    font-size: 3.87vw;

    margin-right: 1.33vw;
  }

  .user-recharge-page .recharge-content .ch-tab-box .ch-tab .profit-tag {
    position: absolute;
    top: -2.67vw;
    right: -2.67vw;
    width: 8.93vw;
    height: 5.2vw;
    line-height: 5.2vw;

    font-size: 3.33vw;
  }

  .user-recharge-page
    .recharge-content
    .new-s-custom-tabs-wrap
    .s-custom-tab-bar {
    width: 386.4px;
    margin: 0 4vw;
  }

  .user-recharge-page .recharge-content .bottom-btn-wrap {
    margin-top: 4vw;
    padding: 0 4vw 2.67vw;
  }

  .user-recharge-page .recharge-content .bottom-btn-wrap .left-total-amount {
    width: 43.47vw;
    height: 10.8vw;
  }

  .user-recharge-page
    .recharge-content
    .bottom-btn-wrap
    .left-total-amount
    .amount-label {
    font-size: 3.33vw;
    line-height: 3.33vw;

    width: 6.67vw;
    height: 6.67vw;
    margin: 2vw 2.4vw;
  }

  .user-recharge-page
    .recharge-content
    .bottom-btn-wrap
    .left-total-amount
    .amount-font {
    padding-right: 5.33vw;
    margin-left: 4vw;

    font-size: 4.4vw;
  }

  .user-recharge-page
    .recharge-content
    .bottom-btn-wrap
    .left-total-amount
    .amount-font
    .unit {
    padding-left: 1.33vw;
    font-size: 3.33vw;
  }

  .user-recharge-page .recharge-content .bottom-btn-wrap .recharge-btn {
    width: 42.8vw;
    height: 12.93vw;
    line-height: 12.93vw;

    font-size: 5.07vw;
  }

  .user-recharge-page .recharge-content .bottom-btn-wrap::after {
    height: 22.974px;

    bottom: 19.6vw;
  }

  .user-recharge-page .recharge-content .goods-recharge .tab-bar-line {
    width: 397.614px;
    height: 8.946px;
    margin-left: 2.67vw;
  }

  .user-recharge-page .recharge-content .goods-recharge .recharge-btn {
    width: 68.8vw;
    height: 20.27vw;
    margin: 14.53vw 0 0 122.974px;
  }

  .user-recharge-page .recharge-content .goods-recharge .goods-tip {
    height: 8vw;
    margin-top: 6.13vw;
  }

  .user-recharge-page .recharge-content .goods-recharge .goods-tip .tag-ic {
    display: inline-block;
    width: 3.73vw;
    height: 3.33vw;
  }

  .user-recharge-page .recharge-content .goods-recharge .goods-tip .text {
    font-size: 3.33vw;

    margin-left: 1.2vw;
  }

  .user-recharge-page .recharge-content .goods-recharge .goods-tip .bind-btn {
    display: inline-block;
    width: 21.6vw;
    height: 6.67vw;
    line-height: 6.67vw;
    font-size: 2.67vw;

    margin-left: 5.73vw;
  }

  .user-recharge-page .recharge-content .goods-recharge .goods-tip1 {
    font-size: 4vw;
    margin-top: 4vw;
  }

  .user-recharge-page .recharge-content .goods-recharge .to-transfer {
    bottom: 23.73vw;
  }

  .user-recharge-page .recharge-content .goods-recharge .to-transfer .viewider {
    width: 99.07vw;
  }

  .user-recharge-page .recharge-content .goods-recharge .to-transfer .go-btn {
    width: 42.8vw;
    height: 12.93vw;
    line-height: 12.93vw;
    font-size: 5.07vw;

    font-weight: 700;
    margin: 4vw 28.67vw 2.53vw 0;
  }

  .user-recharge-page .error-empty-text {
    font-size: 4.8vw;
    margin-top: 40vw;
  }

  .user-recharge-page .user-recharge-title-img {
    width: 12.4vw;
    height: 5.07vw;
  }

  .user-recharge-page .recharge-tips {
    padding: 0 5.33vw 2.67vw;
    font-size: 3.33vw;
  }

  .user-recharge-page .recharge-tips image {
    margin-right: 1.33vw;
    width: 3.73vw;
    height: 3.33vw;
  }

  .user-recharge-page .recharge-amount-wrap {
    padding: 0 4vw 0 4vw;
  }

  .user-recharge-page .recharge-amount-wrap .recharge-amount-content-list {
    padding-bottom: 10.67vw;
  }

  .user-recharge-page
    .recharge-content
    .new-s-custom-tabs-wrap
    .s-custom-tab-content-wrap {
    height: calc(100vh - 80vw);
    margin-top: 4vw;
  }

  .user-recharge-page .recharge-amount-wrap .amount-item {
    width: 29%;
    height: 20.4vw;

    background-size: 100% 100%;
    margin-right: 3.2vw;
    margin-bottom: 1.87vw;
  }

  .user-recharge-page .recharge-amount-wrap .amount-item > text {
    font-size: 6.4vw;

    margin-top: -5.33vw;
  }

  .user-recharge-page .recharge-amount-wrap .amount-item .amount-price {
    bottom: -0.67vw;

    height: 6.67vw;
    line-height: 6.67vw;
    font-size: 3.33vw;
  }

  .user-recharge-page .recharge-amount-wrap .amount-item .zengsong-tag-wrap {
    width: 22.67vw;
    height: 4.53vw;
    top: 0.53vw;
    left: 0.93vw;
  }

  .user-recharge-page
    .recharge-amount-wrap
    .amount-item
    .zengsong-tag-wrap
    text {
    display: inline-block;
    width: 22.67vw;
    height: 4.53vw;
    line-height: 4.53vw;
    font-size: 3.33vw;
    padding: 0 0 0 1.07vw;
  }

  .user-recharge-page .recharge-amount-wrap .amount-item .size-mask {
    margin-bottom: 4vw;
  }

  .user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size {
    width: 9.73vw;
    height: 9.87vw;
  }

  .user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-2 {
    width: 11.6vw;
    height: 9.6vw;
  }

  .user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-3 {
    width: 12.67vw;
    height: 9.47vw;
  }

  .user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-4 {
    width: 11.47vw;
    height: 9.47vw;
  }

  .user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-5 {
    width: 14vw;
    height: 9.73vw;
  }

  .user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-6 {
    width: 14vw;
    height: 9.73vw;
  }

  .user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-7 {
    width: 14vw;
    height: 9.73vw;
  }

  .user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-8 {
    width: 17.47vw;
    height: 10.4vw;
  }

  .user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-9 {
    width: 18vw;
    height: 15.2vw;
  }

  .user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-10 {
    width: 12.8vw;
    height: 9.6vw;
  }

  .user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-11 {
    width: 12.53vw;
    height: 12.27vw;
  }

  .user-recharge-page .recharge-amount-wrap .amount-item .size-mask.size-12 {
    width: 23.2vw;
    height: 14.4vw;
  }

  .user-recharge-page .recharge-amount-total {
    padding: 5.73vw 2.67vw 0 2.67vw;
  }

  .user-recharge-page .recharge-amount-total .btn-center {
    width: 41.07vw;
  }

  .user-recharge-page .recharge-amount-total .conversion-of-rmb-wrap {
    width: 53.6vw;
  }

  .user-recharge-page
    .recharge-amount-total
    .conversion-of-rmb-wrap
    .selected-recharge-text {
    font-size: 2.93vw;
  }

  .user-recharge-page
    .recharge-amount-total
    .conversion-of-rmb-wrap
    .selected-recharge {
    font-size: 6vw;

    font-weight: 600;
  }

  .user-recharge-page
    .recharge-amount-total
    .conversion-of-rmb-wrap
    .selected-recharge
    text {
    font-size: 2.67vw;
  }

  .user-recharge-page
    .recharge-amount-total
    .conversion-of-rmb-wrap
    .cdkey-input-box {
    width: 55.2vw;
    height: 9.33vw;
  }

  .user-recharge-page
    .recharge-amount-total
    .conversion-of-rmb-wrap
    .cdkey-input-box
    input {
    width: 53.33vw;
    height: 100%;
    text-indent: 1.6vw;

    font-size: 3.73vw;
  }

  .user-recharge-page .recharge-amount-total .recharge-btn {
    font-size: 3.47vw;

    width: 41.07vw;
    height: 9.33vw;
    line-height: 9.33vw;
  }

  .user-recharge-page .recharge-amount-total .hitCol {
    padding-top: 1.07vw;
    font-size: 1.6vw;
  }

  .user-recharge-page .recharge-total-box {
    width: 100%;

    padding: 5.33vw 4vw 0 4vw;
  }

  .user-recharge-page .recharge-total-box .prod-info .left-img {
    width: 30.4vw;
    height: 22.67vw;
  }

  .user-recharge-page .recharge-total-box .prod-info .prod-name {
    width: 57.33vw;
    height: 5.33vw;
    margin-top: 1.33vw;
  }

  .user-recharge-page .agCol {
    padding: 6.67vw 2.67vw 0 2.67vw;
  }

  .user-recharge-page .agree-error-text {
    font-size: 3.2vw;
    padding: 0 3.2vw;

    height: 3.47vw;
    line-height: 3.47vw;
    margin-top: 3.2vw;
  }

  .dialog-box .user-recharge-page .bottom-btn-wrap {
    margin-bottom: 4vw;
  }

  .new-s-custom-tabs-wrap {
    padding-top: 5.33vw;
    height: 58vh;
    flex: unset !important;
  }

  .new-s-custom-tabs-wrap .s-custom-tab-bar {
    height: 12vw;
  }

  .new-s-custom-tabs-wrap .s-custom-tab-bar .custom-tab-item {
    width: 26.67vw;
    height: 7.73vw;
    line-height: 7.73vw;
    font-size: 3.33vw;
  }

  .new-s-custom-tabs-wrap .s-custom-tab-bar .custom-tab-item .icon {
    width: 4.13vw;
    height: 3.2vw;

    margin-right: 1.33vw;
  }

  .recharge-tab .s-custom-tab-bar .tab-inner .custom-tab-item {
    width: 21.6vw;
    margin-right: 1.73vw;
    margin-bottom: 2.8vw;
  }

  .recharge-tab .s-custom-tab-bar .tab-inner .custom-tab-item .tab-icon {
    width: 4vw;
    height: 4vw;
    margin-right: 1.07vw;
    -webkit-border-radius: 0.67vw;
    border-radius: 0.67vw;
  }

  .recharge-tab .s-custom-tab-bar .tab-inner .custom-tab-item text {
    font-size: 3.33vw;
  }

  .recharge-tab .tab-bar-line {
    width: 397.614px;
    height: 8.946px;
    margin-left: 2.67vw;
    background-size: 397.614px 8.946px;
  }
}
</style>
